const { axiosCreate } = require('./Api')
const { checkResponse } = require('../controllers/errorHandler')

import dayjs from 'dayjs'
import i18n from '@/locales/index'
import store from '../state/store'

import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

async function getCart({ warehouse } = {}) {
  if (store.state.activeWarehouse === '' && !warehouse) return
  const result = await axiosCreate.get(`shop/cart`, {
    headers: { authorization: store.getters.token },
    params: {
      ContactID: store.getters.contactID,
      sorton: 'ranking',
      warehouse: warehouse
    }
  })

  if ((await checkResponse(result)) !== null) return

  if (result.data) {
    store.commit('setCart', {
      cart: result.data
    })
  }

  store.commit('setDateTimeExpectedStart', {
    date: dayjs(result.data.DateTimeExpectedStart, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeExpectedEnd', {
    date: dayjs(result.data.DateTimeExpectedEnd, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeBusinessStart', {
    date: dayjs(result.data.DateTimeExpectedStart, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeBusinessEnd', {
    date: dayjs(result.data.DateTimeExpectedEnd, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setActiveWarehouseID', {
    warehouseID: result.data.WarehouseID
  })

  let cartItems = []

  if (result.data.CartItems && result.data.CartItems.Collection) {
    result.data.CartItems.Collection.forEach(cartItem => {
      cartItems.push({
        item: cartItem.Description,
        cartItemID: cartItem.CartItemID,
        price: cartItem.PriceIncVAT,
        amount: cartItem.Amount || 0,
        delete: cartItem.CartItemID,
        itemType: cartItem.ItemType,
        total: cartItem.PriceIncVAT,
        maxAdded: cartItem.MaxPerCustomerLeftover,
        maxPerCustomer: cartItem.MaxPerCustomer
      })
    })

    cartItems = cartItems.filter(function(obj) {
      return obj.item !== 'Administratiekosten'
    })
  }

  return cartItems
}

async function getBusinessHours({ start, end, warehouseID }) {
  const result = await axiosCreate.get(`shop/businessdays/BusinessHours`, {
    params: {
      contactID: store.getters.contactID,
      WarehouseID: warehouseID,
      Start: dayjs(start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      End: dayjs(end, 'DD-MM-YYYY').format('YYYY-MM-DD')
    },
    headers: { authorization: store.getters.token }
  })

  if ((await checkResponse(result)) !== null) return

  let startHours = []
  let endHours = []

  for (let hourObject of result.data.BusinessHourStart) {
    startHours.push({
      value: hourObject.BusinessHour,
      text: hourObject.BusinessHour
    })
  }

  for (let hourObject of result.data.BusinessHourEnd) {
    endHours.push({
      value: hourObject.BusinessHour,
      text: hourObject.BusinessHour
    })
  }

  const hours = {
    startHours,
    endHours
  }

  return hours
}

async function checkout({ notes, AddressTel }) {
  const result = await axiosCreate.post(
    `shop/cart/checkout`,
    { notes, AddressTel, AddressCity: '-' },
    {
      params: {
        ContactID: store.getters.contactID
      },
      headers: { authorization: store.getters.token }
    }
  )

  if ((await checkResponse(result)) !== null) return

  return result
}

async function addToCartSimple({ itemID, compositionID } = {}) {
  const result = await axiosCreate.post(
    `custcart/cartItems`,

    {
      ItemID: itemID,
      ContactID: store.getters.contactID,
      CompositionID: compositionID
    },

    { headers: { authorization: store.getters.token } }
  )

  if ((await checkResponse(result)) !== null) return

  return result
}

async function addToCart({
  warehouseID,
  dateTimeBusinessStart,
  dateTimeBusinessEnd,
  itemID,
  compositionID,
  amount
} = {}) {
  const result = await axiosCreate.post(
    `shop/cart/cartitems`,
    [
      {
        WarehouseID: warehouseID,
        DateTimeBusinessStart: dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
          'YYYY-MM-DD'
        ),
        DateTimeBusinessEnd: dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
          'YYYY-MM-DD'
        ),
        DateTimeExpectedStart: dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
          'YYYY-MM-DD'
        ),
        DateTimeExpectedEnd: dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
          'YYYY-MM-DD'
        ),
        ItemID: itemID,
        CompositionID: compositionID,
        Amount: amount
      }
    ],
    {
      headers: { authorization: store.getters.token },
      params: {
        ContactID: store.getters.contactID
      }
    }
  )

  if ((await checkResponse(result)) !== null) return

  return result
}

async function updateCartItem({ cartItemID, amount }) {
  try {
    const result = await axiosCreate.patch(
      `shop/cart/cartitems/${cartItemID}`,
      {
        CartItemID: cartItemID,
        Amount: amount
      },
      {
        headers: { authorization: store.getters.token },
        params: {
          ContactID: store.getters.contactID
        }
      }
    )

    if ((await checkResponse(result)) !== null) return

    return result
  } catch (error) {
    if ((await checkResponse(error)) !== null) return
    return false
  }
}

async function updateCart({
  warehouseID,
  returnWarehouseID,
  businessHourStart,
  businessHourEnd,
  dateTimeBusinessStart,
  dateTimeBusinessEnd
} = {}) {
  const DateTimeExpectedStart = dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
    'YYYY-MM-DD'
  )
  const DateTimeExpectedEnd = dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
    'YYYY-MM-DD'
  )
  const DateTimeBusinessStart = dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
    'YYYY-MM-DD'
  )
  const DateTimeBusinessEnd = dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
    'YYYY-MM-DD'
  )

  const result = await axiosCreate.patch(
    `shop/cart`,
    {
      WarehouseID: warehouseID,
      ReturnWarehouseID: returnWarehouseID,
      BusinessHourStart: businessHourStart,
      BusinessHourEnd: businessHourEnd,
      DateTimeExpectedStart,
      DateTimeExpectedEnd,
      DateTimeBusinessStart,
      DateTimeBusinessEnd
    },
    {
      headers: { authorization: store.getters.token },
      params: {
        ContactID: store.getters.contactID,
        sorton: 'ranking'
      }
    }
  )

  if ((await checkResponse(result)) !== null) return
  if (
    DateTimeExpectedStart !==
      dayjs(result.data.DateTimeExpectedStart).format('YYYY-MM-DD') ||
    DateTimeExpectedEnd !==
      dayjs(result.data.DateTimeExpectedEnd).format('YYYY-MM-DD') ||
    DateTimeBusinessStart !==
      dayjs(result.data.DateTimeBusinessStart).format('YYYY-MM-DD') ||
    DateTimeBusinessEnd !==
      dayjs(result.data.DateTimeBusinessEnd).format('YYYY-MM-DD')
  ) {
    store.commit('sendToast', {
      toastMessage: i18n.t('updated-reservation-period')
    })
  }

  if (result.data) {
    store.commit('setCart', {
      cart: result.data
    })
  }

  store.commit('setDateTimeExpectedStart', {
    date: dayjs(result.data.DateTimeExpectedStart, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeExpectedEnd', {
    date: dayjs(result.data.DateTimeExpectedEnd, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeBusinessStart', {
    date: dayjs(result.data.DateTimeExpectedStart, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  store.commit('setDateTimeBusinessEnd', {
    date: dayjs(result.data.DateTimeExpectedEnd, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )
  })

  if (result.data) {
    store.commit('setCart', {
      cart: result.data
    })
  }

  return result
}

async function deleteCartItem({ cartItemID }) {
  const result = await axiosCreate.delete(`shop/cart/cartitems/${cartItemID}`, {
    headers: { authorization: store.getters.token },
    params: {
      ContactID: store.getters.contactID
    }
  })

  if ((await checkResponse(result)) !== null) return

  return result
}

async function copyCart() {
  const result = axiosCreate.get(
    `shop/cart/copy/${store.state.anonymousToken.replace('Bearer ', '')}`,
    {
      headers: { authorization: store.getters.token },
      params: {
        ContactID: store.getters.contactID
      }
    }
  )
  return result
}

async function cartMutationCheck({
  warehouseID,
  dateTimeBusinessStart,
  dateTimeBusinessEnd
} = {}) {
  const result = await axiosCreate.get(`shop/cart/invalidCartItems`, {
    params: {
      ContactID: store.getters.contactID,
      warehouseID,
      dateTimeBusinessStart: dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
        'YYYY-MM-DD'
      ),
      dateTimeBusinessEnd: dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
        'YYYY-MM-DD'
      ),
      dateTimeExpectedStart: dayjs(dateTimeBusinessStart, 'D/M/YYYY').format(
        'YYYY-MM-DD'
      ),
      dateTimeExpectedEnd: dayjs(dateTimeBusinessEnd, 'D/M/YYYY').format(
        'YYYY-MM-DD'
      )
    },
    headers: { authorization: store.getters.token }
  })
  if ((await checkResponse(result)) !== null) return
  return result.data
}

module.exports = {
  addToCart,
  addToCartSimple,
  copyCart,
  checkout,
  cartMutationCheck,
  deleteCartItem,
  getCart,

  getBusinessHours,
  updateCartItem,
  updateCart
}
